import { ComponentProps } from "react";
import { CiSearch } from "react-icons/ci";

import { Input } from "shared/ui/input";
import { cn } from "shared/utils/cn";

export const SearchInput = ({
  className,
  ...props
}: ComponentProps<"input">) => {
  return (
    <div className={cn("relative flex w-full", className)}>
      <CiSearch className="text-balticSea/50 absolute top-1/2 left-5 size-5.5 -translate-y-1/2" />
      <Input className="pl-9" placeholder="Search" {...props} />
    </div>
  );
};
